import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { showNotification } from './notificationSlice';
import API_ROUTES from "../../config/apiRoutes";

// Create subscription plan
export const createSubscriptionPlan = createAsyncThunk(
  'subscription/createSubscriptionPlan',
  async (planData, { getState, dispatch, rejectWithValue }) => {
    const { token } = getState().auth;
    try {
      const response = await axios.post(
        API_ROUTES.SUBSCRIPTIONS.CREATE,
        planData,
        {
          headers: { 
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
        }
      );
      dispatch(showNotification({ message: "Subscription plan created successfully!", type: "success" }));
      return response.data;
    } catch (error) {
      const message = error.response?.data.message || "Failed to create subscription plan";
      dispatch(showNotification({ message, type: "error" }));
      return rejectWithValue(message);
    }
  }
);

// Update subscription plan
export const updateSubscriptionPlan = createAsyncThunk(
  'subscription/updateSubscriptionPlan',
  async ({ planId, planData }, { getState, dispatch, rejectWithValue }) => {
    const { token } = getState().auth;
    try {
      const response = await axios.patch(
        API_ROUTES.SUBSCRIPTIONS.UPDATE(planId),
        planData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          },
        }
      );
      dispatch(showNotification({ message: "Subscription plan updated successfully!", type: "success" }));
      return response.data;
    } catch (error) {
      const message = error.response?.data.message || "Failed to update subscription plan";
      dispatch(showNotification({ message, type: "error" }));
      return rejectWithValue(message);
    }
  }
);

export const deleteSubscriptionPlan = createAsyncThunk(
  'subscription/deleteSubscriptionPlan',
  async (planId, { getState, dispatch, rejectWithValue }) => {
    const { token } = getState().auth;
    try {
      const response = await axios.delete(
        API_ROUTES.SUBSCRIPTIONS.DELETE(planId),
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      dispatch(showNotification({ message: response.data.message, type: "success" }));
      return planId;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to delete subscription plan";
      dispatch(showNotification({ message, type: "error" }));
      return rejectWithValue(message);
    }
  }
);

const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: { plans: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(createSubscriptionPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createSubscriptionPlan.fulfilled, (state, action) => {
        state.loading = false;
        state.plans.push(action.payload);
      })
      .addCase(createSubscriptionPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateSubscriptionPlan.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateSubscriptionPlan.fulfilled, (state, action) => {
        state.loading = false;
        const updatedPlan = action.payload;
        const index = state.plans.findIndex(plan => plan._id === updatedPlan._id);
        if (index !== -1) {
          state.plans[index] = updatedPlan;
        }
      })
      .addCase(updateSubscriptionPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteSubscriptionPlan.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
     });
  },
});

export default subscriptionSlice.reducer;
